import React from "react";
import { Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiCogOutline } from "@mdi/js";
import CardShell from "./CardShell";
import BookingNote from "./BookingNote";
import { formatMoney } from "app/containers/Jobs/utils/format";

const JobSetupCard = ({ job, onEdit }) => {
  const setup = job.job_setup || {};
  const isSetup = setup.is_setup;

  return (
    <CardShell
      icon={<Icon path={mdiCogOutline} size={0.7} className="jd-card-icon" />}
      title="Job Setup"
      headerRight={
        isSetup ? (
          <Button variant="outline-secondary" size="sm" onClick={onEdit}>
            Edit
          </Button>
        ) : (
          <Button variant="primary" size="sm" onClick={onEdit}>
            Set Up Job
          </Button>
        )
      }
    >
      <div className="jd-setup-grid">
        <div>
          <span className="jd-label">Section Template</span>
          <span className="jd-value">
            {isSetup ? setup.template_name || "Standard Sections" : "-"}
          </span>
        </div>
        <div>
          <span className="jd-label">Quote</span>
          <span className="jd-value">
            {isSetup && setup.quote != null ? formatMoney(setup.quote) : "-"}
          </span>
          {isSetup && setup.note && <BookingNote note={setup.note} inline />}
        </div>
      </div>
    </CardShell>
  );
};

export default JobSetupCard;
